import { useTranslation } from "../context/LanguageContext";
import { formatPrice, type MultiBuyPriceDisplay } from "./ProductItem.utils";

export const ProductOfferPrice = ({
  display,
  size = "row",
}: {
  display: MultiBuyPriceDisplay;
  /** card: headline on its own line, compact chips that wrap whole beneath it. */
  size?: "row" | "hero" | "card";
}) => {
  const { t } = useTranslation();
  const hero = size === "hero";
  const card = size === "card";
  return (
    <>
      <span className={hero
        ? "text-lg font-bold text-emerald-600 dark:text-emerald-400 leading-tight"
        : card
          ? "basis-full text-[15px] leading-5 font-extrabold tracking-tight text-emerald-700 dark:text-emerald-400"
          : "text-[13px] leading-none font-bold text-emerald-600 dark:text-emerald-400"}>
        {display.headline}
      </span>
      {display.regularEach > 0 && (
        <span className={`${hero ? "text-sm" : card ? "text-[10px] whitespace-nowrap" : "text-[13px]"} font-semibold tabular-nums text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-dark-700 px-1.5 py-0.5 rounded-md`}>
          {t("products.regularEach", { amount: formatPrice(display.regularEach) })}
        </span>
      )}
      {display.unitInDeal > 0 && display.qty > 1 && (
        <span className={`${hero ? "text-xs font-bold" : "text-[10px] font-bold"} ${card ? "whitespace-nowrap" : ""} tabular-nums text-sky-700 dark:text-sky-300 bg-sky-500/10 dark:bg-sky-900/40 px-1.5 py-0.5 rounded-md`}>
          {t("products.unitInDeal", { amount: formatPrice(display.unitInDeal), count: String(display.qty) })}
        </span>
      )}
      {display.percentOff > 0 && (
        <span className={`${hero ? "text-[10px] font-extrabold" : "text-[10px] font-bold"} ${card ? "whitespace-nowrap" : ""} tabular-nums text-red-600 dark:text-red-300 bg-red-500/10 dark:bg-red-900/40 px-1.5 py-0.5 rounded-md`}>
          {t("products.percentOffInDeal", { percent: String(display.percentOff) })}
        </span>
      )}
    </>
  );
};
